import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/chart-down.svg";
var ChartDownOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ChartDownOutline_default as default
};
